import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

const remoteSpotSlugNotFoundStatus = 204;

function useSpotAPI() {
  const { userRef, menuIdRef, languageRef } = useStorage();

  function loadSpotFromRemote(id) {
    const url = `/vbeta2/menu/spots/${id}`;

    return axios({
      url,
      method: 'get',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function findSpotsFromRemote() {
    const url = `/vbeta2/menu/spots`;

    return axios({
      url,
      method: 'get',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  // ANTIGOS:::

  function spotCheckInFromRemote(spotId) {
    const url = `/vbeta2/menu/spots/${spotId}/checkin`;

    return axios({
      url,
      method: 'post',
      data: null,
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    loadSpotFromRemote,
    findSpotsFromRemote,
    remoteSpotSlugNotFoundStatus,
    spotCheckInFromRemote,
  };
}

export { remoteSpotSlugNotFoundStatus, useSpotAPI };
